import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app",
  "use": "icon-app-usage",
  "viewBox": "0 0 29 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 34\" id=\"icon-app\"><g transform=\"translate(2 3)\" stroke-width=\"3\" fill=\"transparent\" stroke=\"currentColor\"><rect x=\"1.5\" y=\"1.5\" width=\"22\" height=\"24.5\" rx=\"4\" /><path stroke-linecap=\"round\" d=\"M7.5 9.577h9.615m-9.615 8h9.615\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol